import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { catchError, finalize } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { inject } from '@angular/core';
import { LoadingService } from '../services/loading.service';

const excludedUrls = ['/v1.0/attachments/getFile', '/assets'];

/**
 * Set on a request whose component shows its own progress — an upload with a per-file bar,
 * say — so the full-screen spinner does not cover the very thing reporting it.
 */
export const SKIP_GLOBAL_LOADING = new HttpContextToken<boolean>(() => false);

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  if (req.context.get(SKIP_GLOBAL_LOADING) || excludedUrls.some((url) => req.url.includes(url))) {
    return next(req);
  }

  loadingService.totalRequests++;

  if (loadingService.totalRequests >= 1) {
    loadingService.setLoading(true);
  }

  const decrementRequests = () => {
    loadingService.totalRequests--;
    if (loadingService.totalRequests <= 0) {
      loadingService.totalRequests = 0;
      loadingService.setLoading(false);
    }
  };

  return next(req).pipe(
    catchError((error) => {
      decrementRequests();
      return throwError(() => error);
    }),
    finalize(() => {
      decrementRequests();
    }),
  );
};
